import { render, staticRenderFns } from "./sinesters-clients.vue?vue&type=template&id=3ad0cd48"
import script from "./sinesters-clients.vue?vue&type=script&lang=js"
export * from "./sinesters-clients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports